module.exports = __webpack_public_path__ + "@/assets/img/sa100.39c69f4b.jpeg";